import React, { useContext } from 'react';
import classNames from 'classnames';
import WorkflowConfigurationRouter from '../../subrouters/WorkflowConfiguration/WorkflowConfiguration.router';
import ListingContext from '../../providers/Listing/Listing.context';
import NotPaidDeal from 'components/NotPaidDeal';
import HelmetWrapper from 'components/HelmetWrapper';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Navigate } from 'react-router-dom';

import './Settings.styles.scss';
import './Settings.styles.responsive.scss';

type SettingsProps = {
  className?: string;
};

const Settings: React.FC<SettingsProps> = (props) => {
  const { className } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);

  const {
    canManageDeal,
    dealRoom,
    listing,
    areActionsDisabled,
    hasUnlockPremiumFeatures,
  } = useContext(ListingContext);

  const classes = classNames('settings', className);

  if (!canManageDeal) return <Navigate to="../" replace />;

  if (!hasUnlockPremiumFeatures && !isSuperAdmin) {
    return (
      <NotPaidDeal
        dealRoomId={dealRoom._id}
        listingId={listing?._id}
        listingType={listing?.type}
        isDisabled={areActionsDisabled}
      />
    );
  }

  return (
    <div className={classes}>
      <HelmetWrapper title={`Automation - ${dealRoom?.name}`} />
      <WorkflowConfigurationRouter />
    </div>
  );
};

export default Settings;
